import { createContext } from 'react'
import type { Business, SessionUser } from '@/types/api'

export type AuthState = {
  user: SessionUser | null
  business: Business | null
  loading: boolean
  error: string | null
  login: (email: string, password: string) => Promise<void>
  logout: () => Promise<void>
  refreshProfile: () => Promise<void>
  switchEnvironment: (environment: 'SANDBOX' | 'PRODUCTION') => Promise<void>
  hasPermission: (permission: string) => boolean
}

export const AuthContext = createContext<AuthState | null>(null)
